/* eslint-disable @typescript-eslint/consistent-type-imports */
/* eslint-disable*/
import { Component, EventEmitter, HostListener, Input, OnInit, Output, ViewEncapsulation, ElementRef, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AppEnvConfig } from '../../app.env.config';
import { CommanClass } from '../_enum/constants';
import { MenuItems, SelectedMenus } from '../contracts/menu';
import { MenuService } from '../menu.service';
import { DividerOption } from './../../shared-ui-refresh/divider/divider.model';
import { environment } from '../../../environments/environment';

@Component({
    selector: 'nalco-menu-item',
    templateUrl: './menu-item.component.html',
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class MenuItemComponent implements OnInit {

  showMenu = true;
  @Input() id: number;
  @Input() text: string;
  @Input() heading: string;
  @Input() link: string;
  @Input() href: string;
  @Input() icon: string;
  @Input() tooltip: string;
  @Input() selected: boolean;
  @Input() subMenu: MenuItems[];
  @Input() arrow: string;
  @Input() isMidNavigation: boolean = false; // Indicates if this item is in mid-navigation
  @ViewChild('menuItemElement', { static: false }) menuItemElement: ElementRef;
  isExpand: boolean;
  dividerCss: DividerOption;
  showDropDown = false;
  // additional property to set any additional feature for menu
  // for RK it is for feedback floating down
  @Input() itemContainerClass: string;
  @Output() menuItemClick: EventEmitter<MenuItems> = new EventEmitter();
  siteId: string;
  toggle = false;
  isMobile = false;
  showSubMenu = false;
  isE3DChina = (this.config.getEnv("IsE3DChina") === "true") ? true : false;
  cloud = '';
  submenuTopPosition: string = 'auto';
  submenuMaxHeight: string = 'none';
  constructor(private translate: TranslateService,
    private menuService: MenuService,
    private config: AppEnvConfig) { }

  ngOnInit() {
    this.isMobile = (/android|webos|iphone|ipad|ipod|blackberry|windows phone/).test(navigator.userAgent.toLowerCase());
    this.showSubMenu = this.subMenu.length > 0 ? true : false;
    this.menuService.navExpand.subscribe((value) => {
      this.isExpand = value,
        this.unSelectMenu();
        this.showArrowByViewMode();
    }
    )
    this.dividerCss = {
      color: "#bac7d8",
      maxLength: "auto",
      isHorizontal: true
    }
    this.cloud = environment.cloudEnv ?  environment?.cloudEnv?.toLowerCase() : '';

  }

  @HostListener('document:click', ['$event']) clickedOutside(event) {
    if (event.target.className.indexOf !== undefined
      && event.target.className.indexOf('menu-text') < 0) {
      this.showMenu = false;
    }
    if (!this.isMobile && (typeof event.target.className === 'string' &&
        (event.target.className.includes(CommanClass.Submenu_Class) || 
         !event.target.className.includes(CommanClass.ShowMenu_Class)))
    ) {
      this.showSubMenu = false;
      this.selected = false;
    }
      if (typeof event.target.className === 'string' &&
          event.target.className.includes(CommanClass.SidebarOpen_Class) && 
          this.isMobile && this.isExpand) {
        this.arrow = 'arrow-down';
      }
  }

  /**
   * @description Check for the navigation open /close and emit the link of the menu clickedl
   */

  public itemClicked(): void {
    this.showSubMenu = this.subMenu.length>0 ? true:false;
    if (this.subMenu !== undefined && this.subMenu.length === 0) {
      this.menuItemClick.emit({ link: this.link, text: this.text });
    } else {
      this.calculateSubmenuPosition();
      this.showDropDownMenu();
      this.showArrowByViewMode();
      this.menuItemClick.emit({ text: this.text });

    }
  }

  /**
   * @description Calculate dynamic submenu position based on menu item's actual position
   * Only applies to mid-navigation items to handle dynamic positioning based on user permissions
   */
  private calculateSubmenuPosition(): void {
    if (this.isMidNavigation && !this.isMobile && this.menuItemElement && this.menuItemElement.nativeElement) {
      const rect = this.menuItemElement.nativeElement.getBoundingClientRect();
      let submenuTop = rect.top;
      const viewportMargin = 16;

      if (this.isAzureToolsMenu() && this.subMenu.length > 9) {
        const submenuHeight = this.calculateEstimatedSubmenuHeight();
        const minTop = viewportMargin;
        const maxTop = Math.max(window.innerHeight - submenuHeight - viewportMargin, minTop);
        submenuTop = Math.min(Math.max(submenuTop, minTop), maxTop);
      }

      const minVisibleHeight = 280;
      const availableBelow = window.innerHeight - submenuTop - viewportMargin;
      if (availableBelow < minVisibleHeight) {
        submenuTop = Math.max(window.innerHeight - minVisibleHeight - viewportMargin, viewportMargin);
      }
      this.submenuMaxHeight = `${window.innerHeight - submenuTop - viewportMargin}px`;

      this.submenuTopPosition = `${submenuTop}px`;
    }
  }

  private isAzureToolsMenu(): boolean {
    return this.cloud === 'azure' && this.text === 'LEFT_NAV.MAIN_NAV_TOOLS';
  }

  private calculateEstimatedSubmenuHeight(): number {
    const itemsPerRow = 3;
    const rowHeight = 55;
    const ulPadding = 45;
    const titleHeight = 55;

    const rows = Math.ceil(this.subMenu.length / itemsPerRow);
    return rows * rowHeight + ulPadding + titleHeight;
  }


  /**
   * @description Check for the submenu selection and emit the item data clicked
   * @param event 
   */
  public subMenuItemClick(event: SelectedMenus): void {
    if (window.location.href.search('/sites/') !== -1) {
      const splitUrl = window.location.href.split('/');
      if (splitUrl.length > 5) {
        this.siteId = splitUrl[5];
      }
    } else {
      this.siteId = null;
    }

    this.menuItemClick.emit({ link: event.link, siteId: this.siteId });
  }

  /**
  * @description this function is used to unselect the menus selected via expand and collapse conditions
  */

  unSelectMenu() : void {
    if (this.subMenu.length > 0 && this.selected) {
      this.selected = false;
    }
  }



  /**
   * @description used to assign the arrow for the left menu as per user click.
   */

  showArrowByViewMode() {
    if (this.isMobile) {
      this.arrow = this.selected ? 'arrow-caret-up' : 'arrow-down';
    }
    else {
      this.arrow = 'arrow-caret-right';
    }
  }

  /**
 * @description Hide and show the dropdown menus according to the user selection
 */

  showDropDownMenu() {
    if (this.subMenu.length > 0 && this.selected) {
      this.showDropDown = false;
      this.selected = false;
    } else {
      this.showDropDown = true;
      this.selected = true;
    }

  }

   /**
 * @description Hide and show the dropdown menus on mouse hover for expand view
 */
  mouseover()
  {
    if(this.isExpand){
      this.calculateSubmenuPosition();
      this.showSubMenu = this.subMenu.length>0 ? true:false;
    }
  }
}
